import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';

/**
 * Routes
 */
const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { animation: 'isRight' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
